import * as yup from "yup";
import { emailRule } from "../../../helpers/validators";

export const emailStepSchema = yup.object({
  email: emailRule(),
});

export const emailStepInitialValues = {
  email: "",
};

export const otpStepSchema = yup.object({
  otp: yup
    .string()
    .required("OTP is required")
    .matches(/^\d{6}$/, "OTP must be 6 digits"),
});

export const otpStepInitialValues = {
  otp: "",
};

// BRD §1.4 password policy: ≥8 chars, ≥1 upper, ≥1 lower, ≥1 digit, ≥1 special.
export const passwordPolicy = yup
  .string()
  .required("New password is required")
  .min(8, "Password must be at least 8 characters")
  .matches(/[A-Z]/, "Include at least one uppercase letter")
  .matches(/[a-z]/, "Include at least one lowercase letter")
  .matches(/\d/, "Include at least one digit")
  .matches(/[^A-Za-z0-9]/, "Include at least one special character");

export const newPasswordStepSchema = yup.object({
  newPassword: passwordPolicy,
  confirmPassword: yup
    .string()
    .required("Please confirm the password")
    .oneOf([yup.ref("newPassword")], "Passwords do not match"),
});

export const newPasswordStepInitialValues = {
  newPassword: "",
  confirmPassword: "",
};
